import { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";

interface ToastsTopLeftProps {
  show: boolean;
  title?: string;
  message?: string;
  type?: "danger" | "success" | "primary" | "warning";
}

const Toasts = (props: ToastsTopLeftProps) => {
  const { show, title, type, message } = props;
  const [showTopLeftToast, setShowTopLeftToast] = useState(show);

  useEffect(() => {
    setShowTopLeftToast(show);
  }, [show]);

  const handleTopLeftToastClose = () => {
    setShowTopLeftToast(false);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowTopLeftToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showTopLeftToast]);

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      <Toast
        className={`toast colored-toast bg-${type}-transparent text-${type}`}
        show={showTopLeftToast}
        onClose={handleTopLeftToastClose}
        id="topleft-Toast"
        bg="primary-transparent"
      >
        <Toast.Header className={`toast-header bg-${type} text-fixed-white`}>
          <strong className="me-auto">{title}</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
};

export default Toasts;
